<template>
  <div class="log">

    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-6">
                <card-title icon-image="mdi-script-text-outline" title="Log" text-color="title" />
              </div>
              <div class="col-xl-6 text-align-end">
                <span class="fw-bold">{{ nowDate }}</span>
                <span class="ct-padding-left-75 mt-1">{{ nowTime }}</span>
                <span class="mdi mdi-refresh mdi-spin mdi-18px icon-padding-left ct-text-muted"
                      style="cursor: pointer" @click="getItems()">
                </span>
              </div>
            </div>

            <MDKTable
                ref="MDKTable"
                :fields="fields"
                :items="items"
                :pagination="paginationOptions"
                v-on:filter-change="getItems" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CardTitle from '@/views/components/cardTitle.vue';

export default {
  components: { CardTitle },
  data() {
    const _api = this.$_app.service.ocppLog;
    return {
      nowDate: null,
      nowTime: null,
      jqlApi: _api,
      fields: _api.columnInfos,
      items: [],
      paginationOptions: {
        currentPage: 1,
        totalCount : 0,
        perPage: 10,
      }
    }
  },
  mounted() {
    const vm = this;
    vm.getItems();
  },
  methods: {
    getItems(filterOptions, sortOptions) {
      const vm = this;
      vm.nowDate = this.$_utils.nowDate() + ' (' + this.$_utils.nowDay() + ')';
      vm.nowTime = this.$_utils.nowTime();

      sortOptions = '-id';
      vm.jqlApi.searchByJql(filterOptions, sortOptions, vm.paginationOptions.perPage, vm.$refs.MDKTable.currentPage)
          .then(res => {
            vm.items = res.content;
            vm.paginationOptions.totalCount = res.totalElements;
          }).catch(err => {
            console.log(err);
          });
    }
  }
}
</script>
